import React from "react";

function ProjectStrategy() {
  return (
    <div className="expertise-container" id="project-strategy">
      <div className="skills-container">
        <h1 className="section-title">Project Strategy</h1>

        <div className="strategy-intro">
          {/* intro text here */}
        </div>

        <div className="strategy-grid">
          {/* strategy items here */}
        </div>
      </div>
    </div>
  );
}

export default ProjectStrategy;